import * as React from 'react';

import { IconButton } from '../../icon/button/icon-button';
import {
    IconButtonSizeType,
    IconButtonVariantType,
    IconButtonVariationType,
} from '../../../../theme/type/icon-button-type';
import { Tooltip } from '../../tooltip/tooltip';

export interface TableActionPropsInterface {
    icon: React.ReactNode;
    label?: string;
    variant?: IconButtonVariantType;
    variation?: IconButtonVariationType;
    onClick?: () => void;
    disabled?: boolean;
    loading?: boolean;
    size?: IconButtonSizeType | object;
    className?: string;
}

export const TableAction: React.FC<TableActionPropsInterface> = ({
    icon,
    onClick,
    variant = 'default',
    variation = 'filled',
    size = 'small',
    disabled,
    loading,
    label,
    className,
}) => {
    return (
        <div className={className ? `table-action inline-flex ${className}` : 'table-action inline-flex'}>
            <Tooltip content={label} position="top-right" arrowPosition={1.4}>
                <IconButton
                    onClick={onClick}
                    variant={variant}
                    variation={variation}
                    loading={loading}
                    icon={icon}
                    size={size}
                    disabled={disabled}
                />
            </Tooltip>
        </div>
    );
};
